module.exports = __webpack_public_path__ + "static/media/img33.f10756e8.jpg";